import { playerActions } from './actions-const';
import { showNotification } from './notifications-actions';
import { play } from './player-actions';
import { NotificationTypes } from '../components/Notifications/Notification';

import AudioPlayerStation from '../players/AudioPlayerStation';
import AudioPlayerOnDemand from '../players/AudioPlayerOnDemand';
import VideoJWPlayer from '../players/VideoJWPlayer';

export function castingStart(castingDevice) {
  return async (dispatch, getState) => {
    AudioPlayerStation.stop(false);
    AudioPlayerOnDemand.stop(false);
    VideoJWPlayer.stop(false);

    dispatch({ type: playerActions.PLAYER_CASTING, castingDevice });

    const {
      player: { isPlaying },
    } = getState();
    if (isPlaying) {
      dispatch(play());
    }
  };
}

export function castingStop() {
  return {
    type: playerActions.PLAYER_CASTING_STOPPED,
  };
}

export function castingPlaybackError(message) {
  return (dispatch) => {
    dispatch(
      showNotification({
        type: NotificationTypes.ERROR,
        message,
      })
    );
  };
}
